import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Icon from '../../../../components/Icon';

import styles from './facts.module.css';

const classNameType = (type, isMobile) => {
  if (type === 'funicular') {
    return isMobile
      ? styles.factsIconFunicularMobile
      : styles.factsIconFunicular;
  }
  if (type === 'ski-in-ski-out') {
    return isMobile
      ? styles.factsIconSkiInSkiOutMobile
      : styles.factsIconSkiInSkiOut;
  }
  if (type === 'wave') return styles.factsIconWave;
  return '';
};

const FactsIcon = ({ type, isMobile }) => (
  <Icon
    className={classnames(
      styles.factsIcon,
      {
        [styles.factsIconMobile]: isMobile,
      },
      classNameType(type, isMobile),
    )}
    type={type}
    isMobile={isMobile}
  />
);

FactsIcon.propTypes = {
  type: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default FactsIcon;
